import centers25 from "@/router/bece/twf/centers.js";
import centers26 from "@/router/bece/tws/centers.js";
import students25 from "./twf/students.js";
import grades25 from "./twf/grades.js";
import payments25 from './twf/payments.js'
import payments26 from './tws/payments.js'
import photo25 from "./twf/photo.js";
import photo26 from "./tws/photo.js";
import gazette26 from './tws/gazette.js'
// 2026
import students26 from "./tws/students.js";
export default [
  {
    path: "/yKwKsSs",
    children: [
    ...students25,
    ...centers25,
    ...grades25,
    ...payments25,
    ...payments26,
    ...centers26,
    ...photo25,
    ...photo26,


    // 2026
    ...students26,


      //GAZzete
      {
        path: "D2tmy2Eg",
        children: [
        ...gazette26,
          {
            path: "/1QzraK",
            name: "bece25.gazettes",
            component: () => import("@/views/bece/twf/gazette/list.vue"),
            meta: {
              title: "Bece 2025 Gazette(s)",
              authRequired: true,
              acc: ["y68184"],
            },
          },
          {
            path: "/y0O8xgRoEb",
            name: "bece25.pendinggazettereq",
            component: () =>
              import("@/views/bece/twf/gazette/pendingrequests.vue"),
            meta: {
              title: "Bece 2025 Pending Gazette Request(s)",
              authRequired: true,
              acc: ["y76563"],
            },
          },
          {
            path: "/Og5OPct",
            name: "bece25.uploadgazette",
            component: () => import("@/views/bece/twf/gazette/upload.vue"),
            meta: {
              title: "Upload Bece 2025 Gazette",
              authRequired: true,
            },
          },
          {
            path: "/NqRWUXQ",
            name: "bece25.uploadedgazettes",
            component: () =>
              import("@/views/bece/twf/gazette/uploaded-gazette.vue"),
            meta: {
              title: "Uploaded Bece 2025 Gazettes",
              authRequired: true,
              acc: ["y10535"],
            },
          },
          {
            path: "/prin-2sw32-3ede-33443as/:er?",
            name: "bece25.gazette",
            component: () => import("@/views/bece/twf/gazette/vgazette.vue"),
            meta: {
              title: "Print Bece Gazette",
              authRequired: true,
              acc: ["y63307"],
            },
          },
         
        ],
      },
    
     
    ],
  },
];
